export const root = '/referral';
export const list = `${root}/list`;
